import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { apiErrorMessage } from '@web/core/http/api-error';
import { FormError } from '@web/modules/auth/form-error';
import { useCase } from '@web/modules/cases/queries';
import { Spinner } from '@web/shared/ui/spinner';

export const Route = createFileRoute('/_app/tickets/$ticketId')({
  component: TicketRoute,
});

/**
 * A link to a ticket (a notification, a message): tickets have no page, so this opens its
 * customer with the ticket in the drawer (spec 056).
 */
function TicketRoute() {
  const { t } = useTranslation();
  const { ticketId } = Route.useParams();
  const ticket = useCase(ticketId);
  if (ticket.isError) {
    return (
      <div className="p-6">
        <FormError message={apiErrorMessage(ticket.error, t, 'cases.loadError')} />
      </div>
    );
  }
  const customerId = ticket.data?.customer?.id;
  if (!customerId) {
    return (
      <div className="p-6">
        {ticket.isPending ? (
          <Spinner size="small" label={t('cases.redirect.loading')} />
        ) : (
          <FormError message={t('cases.detail.notFound')} />
        )}
      </div>
    );
  }
  return (
    <Navigate
      to="/customers/$customerId"
      params={{ customerId }}
      search={{ ticket: ticketId }}
      replace
    />
  );
}
